export enum StatusEnum {
	Inactive = 0,
	Active = 1,
	Deleted = 2,
}
